export const MaxI8  = 127;
export const MaxI16 = 32767;
export const MaxI32 = 2147483647;

export const MaxF32 = 3.40282e+38;
export const MaxF64 = Number.MAX_VALUE;
